import api, { ApiResponse } from './api';

import {
  AlertSettingsUser,
  UpdateAlertSettingsUserProps,
} from 'entities/AlertSettingsUser';

interface GetAlertSettingsUserListResponse {
  success: boolean;
  data: AlertSettingsUser[];
}

export const getAlertSettingsUserListService =
  (): ApiResponse<GetAlertSettingsUserListResponse> =>
    api({
      method: 'GET',
      url: 'alert-settings-user',
      useToken: true,
    });

interface UpdateAlertSettingsUserResponse {
  success: boolean;
  data: AlertSettingsUser;
}

export const updateAlertSettingsUserService = ({
  alertSettingsId,
  ...data
}: UpdateAlertSettingsUserProps): ApiResponse<UpdateAlertSettingsUserResponse> =>
  api({
    method: 'PATCH',
    url: `alert-settings-user/${alertSettingsId}`,
    data,
    useToken: true,
  });
